import React, { useState, useEffect } from 'react'
import "react-datepicker/dist/react-datepicker.css";
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Select from "react-select";
import { useFormik } from 'formik';
import { getCCAirlineList, getCCCountryList, getCCCustomHouseList, getCCEmployeeList, getCCExpJobDetail, getCCPortList, getCCShiplineList, getCCUnusedJobOrderList } from '../../../../../../Redux/action/CustomClearance/CCAction';
import { useNavigate, useParams } from 'react-router-dom';
import { adminMainUrl } from '../../../../../../Config';
import axios from 'axios';
import { convertDateTimeToAPIFormatInCustomClearanceJobOrder, setDateTimeOnCalenderCCExportJobOrder } from '../../../../../../HelperFunctions';
import ExportJobEditOffCanvas from './ExportJobEditOffCanvas';
import Beatloader from '../../../../../../Common/Loaders/Beatloader';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs'
import GeneralTab from './Tabs/GeneralTab';
import ProductTab from './Tabs/ProductTab';
import InvoiceTab from './Tabs/InvoiceTab';
import ShipperTab from './Tabs/ShipperTab';

const ExportJobEdit = ({ accessedModules, accessedPermission }) => {
    const { b64id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [disableSubmit, setDisableSubmit] = useState(false);
    const [activeTab, setActiveTab] = useState("general");
    const [showEditOffcanvas, setShowEditOffcanvas] = useState(false);
    const [disableJobOrderField, setDisableJobOrderField] = useState(true);
    const [trans_mode, setTran_mode] = useState("");
    const handleCloseEditOffcanvas = () => setShowEditOffcanvas(false);
    const handleShowEditOffcanvas = () => setShowEditOffcanvas(true);

    //REACT- SELECT STYLE
    const customStyles = {
        control: (base) => ({
            ...base,
            height: 29,
            minHeight: 29,
            display: 'flex',
            alignItems: 'center',
        }),
        placeholder: (base) => ({
            ...base,
            display: 'flex',
            alignItems: 'center',
            fontSize: '12px',
            fontWeight: "600",
            color: '#808080',
        }),
        menu: (base) => ({
            ...base,
            fontSize: '12px',
        }),
        option: (base) => ({
            ...base,
            fontSize: '12px',
        }),
        singleValue: (base) => ({
            ...base,
            fontSize: '12px',
            display: 'flex', // Ensure singleValue aligns center vertically
            alignItems: 'center',
        }),
    };

    const token = Cookies.get('token');
    const user_id = Cookies.get('flexichain_user_id')
    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;

    useEffect(() => {
        if (token && user_id) {
            dispatch(getCCPortList(token, user_id));
            dispatch(getCCCustomHouseList(token, user_id));
            dispatch(getCCEmployeeList(token, user_id));
            dispatch(getCCUnusedJobOrderList(token, user_id));
            dispatch(getCCCountryList(token, user_id));
            dispatch(getCCAirlineList(token, user_id));
            dispatch(getCCShiplineList(token, user_id));
            if (b64id) {
                let id = atob(b64id);
                if (id) {
                    dispatch(getCCExpJobDetail(token, user_id, id))
                }
            } else {
                toast.error("Please enter correct url.")
                navigate(-1);
            }
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    }, [token, user_id, b64id]);


    const refreshCCExpJob = () => {
        if (token && user_id) {
            if (b64id) {
                let id = atob(b64id);
                if (id) {
                    dispatch(getCCExpJobDetail(token, user_id, id))
                }
            } else {
                toast.error("Something unexpected happened!.")
                // navigate(-1);
            }
        }
    }


    const {
        loadingCCPortList,
        CCPortListDataError,
        CCPortListData,

        loadingCCCustomHouseList,
        CCCustomHouseListData,
        CCCustomHouseListDataError,

        loadingCCEmployeeList,
        CCEmployeeListData,
        CCEmployeeListDataError,

        loadingCCCountryList,
        CCCountryListData,
        CCCountryListDataError,

        loadingCCExpJobDetail,
        CCExpJobDetailData,
        CCExpJobDetailDataError,

        loadingCCShiplineList,
        CCShiplineListData,
        CCShiplineListDataError,

        loadingCCAirlineList,
        CCAirlineListData,
        CCAirlineListDataError,

        loadingCCUnusedJobOrderList,
        CCUnusedJobOrderListData,
        CCUnusedJobOrderListDataError,
    } = useSelector(state => state?.CCReducer);


    const [portOptions, setPortOptions] = useState([]);

    useEffect(() => {
        if (CCPortListData) {
            let arr = [];
            CCPortListData.map((val) => arr.push({ value: val.id, label: `${val.code} - ${val.name},${val.country_name} (${val.port_type})` }));
            setPortOptions(arr);
        }
    }, [loadingCCPortList, CCPortListDataError, CCPortListData]);

    const [jobOrderOptions, setJobOrderOptions] = useState([]);
    useEffect(() => {
        if (CCUnusedJobOrderListData) {
            let arr = [];
            CCUnusedJobOrderListData.map((val) => arr.push({ value: val.id, label: val.job_order_unique_no }));
            setJobOrderOptions(arr);
        }
    }, [loadingCCUnusedJobOrderList, CCUnusedJobOrderListDataError, CCUnusedJobOrderListData]);

    const [airlineOptions, setAirlineOptions] = useState([]);

    useEffect(() => {
        if (CCAirlineListData) {
            let arr = [];
            CCAirlineListData.map((val) => arr.push({ value: val.id, label: val.name }));
            setAirlineOptions(arr);
        }
    }, [loadingCCAirlineList, CCAirlineListDataError, CCAirlineListData]);

    const [shiplineOptions, setShiplineOptions] = useState([]);

    useEffect(() => {
        if (CCShiplineListData) {
            let arr = [];
            CCShiplineListData.map((val) => arr.push({ value: val.id, label: val.name }));
            setShiplineOptions(arr);
        }
    }, [loadingCCShiplineList, CCShiplineListDataError, CCShiplineListData]);


    const [customHouseOptions, setCustomHouseOptions] = useState([]);
    useEffect(() => {
        if (CCCustomHouseListData) {
            let arr = [];
            CCCustomHouseListData.map((val) => arr.push({ value: val.id, label: val.name }));
            setCustomHouseOptions(arr);
        }
    }, [loadingCCCustomHouseList, CCCustomHouseListDataError, CCCustomHouseListData])

    const [employeeOptions, setEmployeeOptions] = useState([]);
    const [countryOptions, setCountryOptions] = useState([]);

    useEffect(() => {
        if (CCEmployeeListData) {
            let arr = [];
            CCEmployeeListData.map((val) => arr.push({ value: Number(val.user_id), label: val.name }));
            setEmployeeOptions(arr);
        }
    }, [loadingCCEmployeeList, CCEmployeeListDataError, CCEmployeeListData])

    useEffect(() => {
        if (CCCountryListData) {
            let arr = [];
            CCCountryListData.map((val) => arr.push({ value: val.id, label: val.name }));
            setCountryOptions(arr);
        }
    }, [loadingCCCountryList, CCCountryListDataError, CCCountryListData])



    const initialValues = {
        job_date_input: "",
        job_received_on_input: "",
        filing_mode_type: "",
        filing_mode_name: "",
        transport_mode: "",
        custom_house_id: "",
        job_owner_id: "",
        loading_port_id: "",
        s_b_type: "",
        consignment_type: "",
        job_order_id: "",
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values) => {
            // console.log(values);
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }

                if (values.job_date_input) { values.job_date = values.job_date_input };
                if (values.job_received_on_input) { values.job_received_on = convertDateTimeToAPIFormatInCustomClearanceJobOrder(values.job_received_on_input) }
                axios.post(`${adminMainUrl}/api/customClearance/add`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            // refresh();
                            navigate(`/flexichain/custom-clearance/export-job/edit/${btoa(response.data.data.id)}`)
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error);
                        let msg = "Internal server error!";
                        if (error.response && error.response.data && error.response.data.msg) {
                            msg = error.response.data.msg
                        }
                        toast.error(msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });

    const [showLoader, setShowLoader] = useState(false);

    useEffect(() => {
        if (loadingCCExpJobDetail) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }

        if (CCExpJobDetailData) {
            // console.log(CCExpJobDetailData);
            setTran_mode(CCExpJobDetailData?.transport_mode);
            formik.setFieldValue("job_date_input", CCExpJobDetailData?.job_date);
            formik.setFieldValue("job_received_on_input", setDateTimeOnCalenderCCExportJobOrder(CCExpJobDetailData?.job_received_on));
            formik.setFieldValue("filing_mode_type", CCExpJobDetailData?.filing_mode_type);
            formik.setFieldValue("filing_mode_name", CCExpJobDetailData?.filing_mode_name);
            formik.setFieldValue("transport_mode", CCExpJobDetailData?.transport_mode);
            formik.setFieldValue("custom_house_id", CCExpJobDetailData?.custom_house_id);
            formik.setFieldValue("job_owner_id", CCExpJobDetailData?.job_owner_id);
            formik.setFieldValue("loading_port_id", CCExpJobDetailData?.loading_port_id);
            formik.setFieldValue("s_b_type", CCExpJobDetailData?.s_b_type);
            formik.setFieldValue("consignment_type", CCExpJobDetailData?.consignment_type);
            formik.setFieldValue("job_order_id", CCExpJobDetailData?.job_order ? CCExpJobDetailData?.job_order?.job_order_unique_no : "-");
        }

    }, [loadingCCExpJobDetail, CCExpJobDetailDataError, CCExpJobDetailData])

    const [showICEgateIDinput, setShowICEgateIDinput] = useState(false);
    useEffect(() => {
        if (formik.values.filing_mode_type == "ICEGATE") {
            setShowICEgateIDinput(true);
        } else {
            setShowICEgateIDinput(false);
        }
    }, [formik.values.filing_mode_type]);

    return (

        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <>
                        <div className="page-wrapper">
                            <div className="content">
                                <div className="row">
                                    <div className="col-md-12">

                                        <div className="page-header">
                                            <div className="row align-items-center">
                                                <div className="col-8">
                                                    <h4 className="page-title">
                                                        Export Job
                                                    </h4>
                                                </div>
                                                {/* <div className="col-4 text-end">
                                                    <div className="head-icons">
                                                        <a
                                                            href="javascript:void(0);"
                                                            data-bs-toggle="tooltip"
                                                            data-bs-placement="top"
                                                            data-bs-original-title="Collapse"
                                                            id="collapse-header"
                                                        >
                                                            <i className="ti ti-chevrons-up" />
                                                        </a>
                                                    </div>
                                                </div> */}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="card">

                                    <div className="card-body">

                                        {/* Filter */}
                                        <form onSubmit={formik.handleSubmit}>
                                            <div className="row d-flex justify-content-end">
                                                <div className="col-md-6 text-end">
                                                    <button type='button' className="btn btn-primary btn-sm" onClick={handleShowEditOffcanvas}>
                                                        <i className="fas fa-edit"></i>
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-end justify-content-between flex-wrap row-gap-2 mb-3">
                                                <div className="d-flex align-items-center flex-wrap row-gap-2">
                                                    <div className="row">
                                                        <div className="col-md-6 mt-2">
                                                            <div className="d-flex justify-content-between">
                                                                <div>
                                                                    <label htmlFor="" className='form-label mb-0'>
                                                                        Job No.
                                                                    </label>
                                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                                        <input
                                                                            type="text"
                                                                            className="form-control form-control-sm"
                                                                            name='order_no'
                                                                            value={CCExpJobDetailData?.job_number}
                                                                            disabled
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6 mt-2">
                                                                    <div className=''>
                                                                        <label htmlFor="" className='form-label  mb-0'>
                                                                            Job Date
                                                                        </label>
                                                                        <div className="icon-forms mb-3 mb-sm-0">
                                                                            <input
                                                                                type="date"
                                                                                className="form-control form-control-sm"
                                                                                name='job_date_input'
                                                                                value={formik.values.job_date_input}
                                                                                disabled={true}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>


                                                        <div className="col-md-6 mt-2">
                                                            <div className=''>
                                                                <label htmlFor="" className='form-label  mb-0'>
                                                                    Tracking No.
                                                                </label>
                                                                <div className="icon-forms mb-3 mb-sm-0">
                                                                    <input
                                                                        type="text"
                                                                        className="form-control form-control-sm"
                                                                        name='job_received_on_input'
                                                                        value={CCExpJobDetailData?.tracking_no}
                                                                        disabled
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mt-2">
                                                            <div className=''>
                                                                <label htmlFor="" className='form-label  mb-0'>
                                                                    Job Recieved On
                                                                </label>
                                                                <div className="icon-forms mb-3 mb-sm-0">
                                                                    <input
                                                                        type="datetime-local"
                                                                        className="form-control form-control-sm"
                                                                        name='job_received_on_input'
                                                                        value={formik.values.job_received_on_input}
                                                                        disabled
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mt-2">
                                                            <div className=''>
                                                                <label htmlFor="" className='form-label  mb-0'>
                                                                    Filing Mode
                                                                </label>
                                                                <div className="icon-forms mb-3 mb-sm-0">
                                                                    <div className="d-flex gap-2">
                                                                        <select
                                                                            className="form-control form-control-sm"
                                                                            name="filing_mode_type"
                                                                            value={formik.values.filing_mode_type}
                                                                            disabled
                                                                        >
                                                                            <option value="" disabled>-</option>
                                                                            <option value="ICEGATE">ICEGATE</option>
                                                                            <option value="Manual">Manual</option>
                                                                            <option value="SEZ">SEZ</option>
                                                                            <option value="Service Center">Service Center</option>
                                                                        </select>
                                                                        {showICEgateIDinput && <input type="text" className="form-control form-control-sm"
                                                                            id="filing_mode_name"
                                                                            name="filing_mode_name"
                                                                            placeholder='Enter ICE Gate ID'
                                                                            value={formik.values?.filing_mode_name}
                                                                            disabled
                                                                        />}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mt-2">
                                                            <div className=''>
                                                                <label htmlFor="" className='form-label  mb-0'>
                                                                    Transport Mode
                                                                </label>
                                                                <div className="icon-forms mb-3 mb-sm-0">

                                                                    <select
                                                                        className="form-control form-control-sm"
                                                                        id="transport_mode"
                                                                        name="transport_mode"
                                                                        value={formik.values.transport_mode}
                                                                        disabled
                                                                    >
                                                                        <option value="" disabled>-</option>
                                                                        <option value="Air">Air</option>
                                                                        <option value="Sea">Sea</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6 mt-2">
                                                            <div className=''>
                                                                <label htmlFor="" className='form-label  mb-0'>
                                                                    Custom House
                                                                </label>
                                                                <Select
                                                                    className='custom-selector'
                                                                    options={customHouseOptions}
                                                                    styles={customStyles}
                                                                    name="custom_house_id"
                                                                    onChange={option => {
                                                                        formik.setFieldValue('custom_house_id', option.value);
                                                                    }}
                                                                    value={customHouseOptions.find(option => option.value === formik.values.custom_house_id) || null}
                                                                    //isLoading={loadingCCCustomHouseList}
                                                                    isDisabled={true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mt-2">
                                                            <div>
                                                                <label htmlFor="" className='form-label  mb-0'>
                                                                    Job Owner
                                                                </label>
                                                                <div className="icon-forms mb-3 mb-sm-0">
                                                                    <Select
                                                                        className='custom-selector'
                                                                        options={employeeOptions}
                                                                        styles={customStyles}
                                                                        name="job_owner_id"
                                                                        onChange={option => {
                                                                            formik.setFieldValue('job_owner_id', option.value);
                                                                        }}
                                                                        value={employeeOptions.find(option => option.value === formik.values.job_owner_id) || null}
                                                                        //isLoading={loadingCCEmployeeList}
                                                                        isDisabled={true}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mt-2">
                                                            <div >
                                                                <label htmlFor="" className='form-label  mb-0'>
                                                                    Loading Port
                                                                </label>
                                                                <div className="icon-forms mb-3 mb-sm-0">
                                                                    <Select
                                                                        className='custom-selector'
                                                                        options={portOptions}
                                                                        styles={customStyles}
                                                                        name="loading_port_id"
                                                                        onChange={option => {
                                                                            formik.setFieldValue('loading_port_id', option.value);
                                                                        }}
                                                                        value={portOptions.find(option => option.value === formik.values.loading_port_id) || null}
                                                                        //isLoading={loadingCCPortList}
                                                                        isDisabled={true}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6 mt-2">
                                                            <div className=''>
                                                                <label htmlFor="" className='form-label  mb-0'>
                                                                    S/B Type
                                                                </label>
                                                                <div className="icon-forms mb-3 mb-sm-0">
                                                                    <select className="form-control form-control-sm"
                                                                        id="s_b_type"
                                                                        name="s_b_type"
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        value={formik.values.s_b_type}
                                                                        disabled
                                                                    >
                                                                        <option value="" disabled>-</option>
                                                                        <option value="White-Free/DEEC">White-Free/DEEC</option>
                                                                        <option value="Green-Drawback">Green-Drawback</option>
                                                                        <option value="Blue-DEBP">Blue-DEBP</option>
                                                                        <option value="Yellow-Dutiable">Yellow-Dutiable</option>
                                                                        <option value="Pink-ExBond">Pink-ExBond</option>
                                                                        <option value="SEZ-Regular">SEZ-Regular</option>
                                                                        <option value="SEZ-ExBond">SEZ-ExBond</option>
                                                                        <option value="SEZ-DTA Procurement">SEZ-DTA Procurement</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {formik.values.transport_mode == "Sea" && <div className="col-md-6 mt-2">
                                                            <div className=''>
                                                                <label htmlFor="" className='form-label  mb-0'>
                                                                    Consignment Type
                                                                </label>
                                                                <div className="icon-forms mb-3 mb-sm-0">
                                                                    <select className="form-control form-control-sm"
                                                                        id="consignment_type"
                                                                        name="consignment_type"
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        value={formik.values.consignment_type}
                                                                        disabled
                                                                    >
                                                                        <option value="" disabled>-</option>
                                                                        <option value="LCL">LCL</option>
                                                                        <option value="FCL">FCL</option>
                                                                        <option value="Break Bulk">Break Bulk</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>}
                                                        <div className="col-md-6 mt-2">
                                                            <div >
                                                                <label htmlFor="" className='form-label  mb-0'>
                                                                    Job Order
                                                                </label>
                                                                <div className="icon-forms mb-3 mb-sm-0">
                                                                    <input
                                                                        type="text"
                                                                        className="form-control form-control-sm"
                                                                        name='job_order_id'
                                                                        value={formik.values.job_order_id}
                                                                        disabled
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                        <div className="row-gap-2">
                                            <div className="tab-content" id="pills-tabContent">
                                                <Tabs
                                                    activeKey={activeTab} // Controlled by state
                                                    onSelect={(k) => setActiveTab(k)} // Update state on tab change
                                                    transition={false}
                                                    id="noanim-tab-example"
                                                    className="nav nav-pills mb-3 custom-tabs gap-0"
                                                >
                                                    <Tab eventKey="general" title="General" className="nav-item" >
                                                        <GeneralTab
                                                            token={token}
                                                            user_id={user_id}
                                                            b64id={b64id}
                                                            loadingCCExpJobDetail={loadingCCExpJobDetail}
                                                            CCExpJobDetailData={CCExpJobDetailData}
                                                            CCExpJobDetailDataError={CCExpJobDetailDataError}
                                                            loadingCCEmployeeList={loadingCCEmployeeList}
                                                            employeeOptions={employeeOptions}
                                                            countryOptions={countryOptions}
                                                            loadingCCCountryList={loadingCCCountryList}
                                                            refresh={refreshCCExpJob}
                                                        />
                                                    </Tab>
                                                    <Tab eventKey="shipper" title="Shipper" className="nav-item" >
                                                        <ShipperTab
                                                            token={token}
                                                            user_id={user_id}
                                                            b64id={b64id}
                                                            refresh={refreshCCExpJob}
                                                            trans_mode={trans_mode}
                                                            loadingCCExpJobDetail={loadingCCExpJobDetail}
                                                            CCExpJobDetailData={CCExpJobDetailData}
                                                            CCExpJobDetailDataError={CCExpJobDetailDataError}

                                                            loadingCCShiplineList={loadingCCShiplineList}
                                                            loadingCCAirlineList={loadingCCAirlineList}
                                                            shiplineOptions={shiplineOptions}
                                                            airlineOptions={airlineOptions}
                                                            loadingCCPortList={loadingCCPortList}
                                                            portOptions={portOptions}
                                                        />
                                                        {/* <GeneralTab token={token} user_id={user_id} b64id={b64id} /> */}
                                                    </Tab>
                                                    <Tab eventKey="invoice" title="Invoice" className="nav-item" >
                                                        <InvoiceTab
                                                            token={token}
                                                            user_id={user_id}
                                                            b64id={b64id}
                                                            refresh={refreshCCExpJob}
                                                        />
                                                        {/* <GeneralTab token={token} user_id={user_id} b64id={b64id} /> */}
                                                    </Tab>
                                                    <Tab eventKey="product" title="Product" className="nav-item" >
                                                        <ProductTab
                                                            token={token}
                                                            user_id={user_id}
                                                            b64id={b64id}
                                                        />
                                                    </Tab>
                                                </Tabs>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ExportJobEditOffCanvas
                            show={showEditOffcanvas}
                            handleClose={handleCloseEditOffcanvas}

                            token={token}
                            user_id={user_id}
                            b64id={b64id}

                            loadingCCPortList={loadingCCPortList}
                            CCPortListDataError={CCPortListDataError}
                            CCPortListData={CCPortListData}

                            loadingCCCustomHouseList={loadingCCCustomHouseList}
                            CCCustomHouseListData={CCCustomHouseListData}
                            CCCustomHouseListDataError={CCCustomHouseListDataError}

                            loadingCCEmployeeList={loadingCCEmployeeList}
                            CCEmployeeListData={CCEmployeeListData}
                            CCEmployeeListDataError={CCEmployeeListDataError}

                            portOptions={portOptions}
                            customHouseOptions={customHouseOptions}
                            employeeOptions={employeeOptions}

                            loadingCCExpJobDetail={loadingCCExpJobDetail}
                            CCExpJobDetailData={CCExpJobDetailData}
                            CCExpJobDetailDataError={CCExpJobDetailDataError}

                            refresh={refreshCCExpJob}
                        />

                    </>
            }
        </>


    )
}

export default ExportJobEdit